export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6532.1004aef7.jpg";